import * as V1 from './v1';
import * as V2 from './v2';

export const AdvancedFiltersContextProvider = {
  V1: V1.AdvancedFiltersView,
  V2: V2.AdvancedFiltersContextProvider,
};

export const AdvancedFiltersContent = {
  V1: V1.AdvancedFiltersContent,
  V2: V2.AdvancedFiltersContent,
};

export const AdvancedFiltersClearAllButton = {
  V1: V1.AdvancedFiltersClearAllButton,
  V2: V2.AdvancedFiltersClearAllButton,
};

export * from './v1/types';
export * from './v2/types';
export * from './v2/components/advanced-filters-default-inputs';
export { createAdvancedFilterConfig } from './v2/utilities/configuration';
